import sileo from 'sileo';
import moment from 'moment-timezone';
import auth from 'source/store/auth';
import router from 'source/router';

const Booking = new sileo.Model('bposeats', 'booking');
const Company = new sileo.Model('bposeats', 'employer-company');
const Facility = new sileo.Model('bposeats', 'facility');
const Feed = new sileo.Model('bposeats', 'feed');
const SiteBookingActivity = new sileo.Model('bposeats', 'site-booking-activity');
const LiveActiveApplicant = new sileo.Model('bposeats', 'live-active-applicant');
const Applicant = new sileo.Model('bposeats', 'applicant');
const ApplicantLocation = new sileo.Model('bposeats', 'applicant-location');
const Locations = new sileo.Model('bposeats', 'facility-location');
const ComputerSpecPart = new sileo.Model('bposeats', 'computer-spec-part');
const InterviewQuestions = new sileo.Model('bposeats', 'interview-questions');
const CustomOffice = new sileo.Model('bposeats', 'custom-office');
const JobPosting = new sileo.Model('bposeats', 'job-postings-feed');
const BookingCheckout = new sileo.Model('bposeats', 'booking-checkout');
const CheckoutBooking = new sileo.Model('bposeats', 'submit-booking');
const PartnerFacility = new sileo.Model('bposeats', 'partner-facility');
const TPBooking = new sileo.Model('bposeats', 'initial-tp-facility');
const TrusterPartner = new sileo.Model('bposeats', 'trusted-partner');
const TrusterPartnerBooking = new sileo.Model('bposeats', 'trusted-partner-booking');
const TrusterPartnerBookingMessages = new sileo.Model('bposeats', 'trusted-partner-booking-messages');
const TrusterPartnerBookingNegotiation = new sileo.Model('bposeats', 'trusted-partner-booking-negotiation');
const TPBookingDashboard = new sileo.Model('bposeats', 'tpbooking-dashboard');
const CampaignInvitedApplicant = new sileo.Model('bposeats', 'campaign-invited-applicant');
const SuggestedTrustedPartner = new sileo.Model('bposeats', 'suggested-trusted-partner');
const TPBookingPreferredBuilding = new sileo.Model('bposeats', 'tpbooking-preferred-buildings');
const JobPostingApplication = new sileo.Model('bposeats', 'job-applications-section');

function initialState() {
    return {
        booking: {},
        employer: {},
        startDate: null,
        selectedFacility: null,
        selectedApplicants: [],
        selectedApplicantsInfo: [],
        applicantFilters: { 'agent': true, 'criterion': 'all' },
        facilityFilters: {},
        maxSalary: 999999,
        maxYearsOfExperience: 50,
        feedItemsCount: 0,
        selectedHeaderLocation: { pk: '' },
        status: null,
        toBeRemoved: [],
        applicantsOrdering: '',
        facilitiesOrdering: '',
    };
}


const state = {
    booking: {},

    employer: {},

    startDate: null,

    selectedFacility: null,

    selectedApplicants: [],

    selectedApplicantsInfo: [],

    applicantFilters: { 'agent': true, 'criterion': 'all' },

    facilityFilters: {},

    maxSalary: 999999,

    maxYearsOfExperience: 50,

    feedItemsCount: 0,

    selectedHeaderLocation: { pk: '' },

    status: null,

    toBeRemoved: [],

    facilityComputerSpecs: [],

    partnerBookingSpecs: [],

    selectedApplicantSubscriptions: [],

    contactInfo: {},

    applicantsOrdering: '',

    facilitiesOrdering: '',
};

const getters = {
    booking: state => state.booking,

    applicantFilters: state => state.applicantFilters,

    facilityFilters: state => state.facilityFilters,

    feedItemsCount: state => state.feedItemsCount,

    maxSalary: state => state.maxSalary,

    maxYearsOfExperience: state => state.maxYearsOfExperience,

    selectedApplicants: state => state.selectedApplicants,

    selectedFacility: state => state.selectedFacility,

    selectedApplicantSubscriptions: state => state.selectedApplicantSubscriptions,

    contactInfo: state => state.contactInfo,

    facilitySpecs: state => state.facilityComputerSpecs,
};

const mutations = {
    setSubscriptions(state, applicants) {
        applicants.forEach(applicant => {
            state.selectedApplicantSubscriptions.push({
                'pk': applicant.pk,
                'is_premium_employed': applicant.is_premium_employed });
        });
    },

    removeSubscriptions(state, applicants) {
        applicants.forEach(applicant => {
            let idx = state.selectedApplicantSubscriptions.findIndex(
                sub => sub.pk == applicant.pk);
            state.selectedApplicantSubscriptions.splice(idx, 1);
        });
    },

    updateBooking(state, booking = {}) {
        state.booking = booking;
    },

    updateEmployer(state, employer) {
        state.employer = employer;
    },

    updateFacility(state, facility_pk = null) {
        state.selectedFacility = facility_pk;
    },

    updateApplicants(state, applicants = []) {
        state.selectedApplicants = applicants.map(applicant => applicant.pk);
        state.selectedApplicantsInfo = applicants.map(applicant => {
            return { ...applicant };
        });
    },

    updateStartDate(state, date = null) {
        if (date) {
            let region = auth.state.user ? auth.state.user.user_profile.region : moment.tz.guess();
            date = moment.tz(date, region).format();
        }

        state.startDate = date;
        state.facilityFilters = { ...state.facilityFilters, start_date: date };
    },

    updateStatus(state, status) {
        state.status = status;
    },

    toggleSelectedApplicant(state, payload) {
        if (payload == null) {
            state.selectedApplicants = [];
            state.selectedApplicantsInfo = [];
        } else {
            const index = state.selectedApplicants.indexOf(payload.pk);
            if (index > -1) {
                state.selectedApplicants.splice(index, 1);
                state.selectedApplicantsInfo.splice(index, 1);
            } else {
                state.selectedApplicants.unshift(payload.pk);
                state.selectedApplicantsInfo.unshift(payload);
            }
        }
    },

    updateExcludedJobPositions(state, pk) {
        if (!state.applicantFilters.seeked_positions_exclude) {
            state.applicantFilters.seeked_positions_exclude = [null];
        }

        let index = state.applicantFilters.seeked_positions_exclude.indexOf(pk);
        if (index > -1) {
            state.applicantFilters.seeked_positions_exclude.splice(index, 1);
        } else {
            state.applicantFilters.seeked_positions_exclude.unshift(pk);
        }

        state.applicantFilters = { ...state.applicantFilters };
    },

    updateJobFocusFilters(state, payload) {
        state.applicantFilters.job_focuses = [...payload.focuses];
        state.applicantFilters.job_specialties = [...payload.specialties];
        state.applicantFilters = { ...state.applicantFilters };
    },

    updateJobFocusFilter(state, payload) {
        state.applicantFilters.job_focuses = [...payload];
        if (!state.applicantFilters.job_focuses.length) {
            delete state.applicantFilters.job_focuses;
        }
        state.applicantFilters = { ...state.applicantFilters };
    },

    removeJobFocusFilters(state) {
        delete state.applicantFilters.job_focuses;
        delete state.applicantFilters.job_specialties;
        state.applicantFilters = { ...state.applicantFilters };
    },

    removeFacilityFocusFilters(state) {
        delete state.facilityFilters.num_of_seats_filter;
        state.facilityFilters = { ...state.facilityFilters };
    },

    updateApplicantSearch(state, payload) {
        if (payload.length >= 1) {
            state.applicantFilters.search = payload;
            state.applicantFilters = { ...state.applicantFilters };
        } else if (payload.length == 0) {
            delete state.applicantFilters['search'];
            state.applicantFilters = { ...state.applicantFilters };
        }
    },

    updateFacilitySearch(state, payload) {
        if (payload.length >= 1) {
            state.facilityFilters.search = payload;
            state.facilityFilters = { ...state.facilityFilters };
        } else if (payload.length == 0) {
            delete state.facilityFilters['search'];
            state.facilityFilters = { ...state.facilityFilters };
        }
    },

    clearApplicantSearch(state) {
        delete state.applicantFilters['search'];
        state.applicantFilters = { ...state.applicantFilters };
    },

    clearApplicantFilters(state) {
        state.applicantFilters = { 'agent': true, 'criterion': 'all' };
    },

    clearFacilitySearch(state) {
        delete state.facilityFilters['search'];
        state.facilityFilters = { ...state.facilityFilters };
    },

    clearFacilityFilters(state) {
        state.facilityFilters = { status: 0 };
    },

    updateFacilityCapacitySearch(state, capacity) {
        if (!isNaN(capacity)) {
            state.facilityFilters.capacity = capacity;
            state.facilityFilters = { ...state.facilityFilters };
        }
    },

    clearFacilityCapacitySearch(state) {
        delete state.facilityFilters['capacity'];
        state.facilityFilters = { ...state.facilityFilters };
    },

    updateSalaryMinimum(state, payload) {
        state.applicantFilters.salary_min = payload;
        state.applicantFilters = { ...state.applicantFilters };
    },

    updateSalaryMaximum(state, payload) {
        state.applicantFilters.salary_max = payload;
        state.applicantFilters = { ...state.applicantFilters };
    },

    updateYearsOfExperienceMinimum(state, payload) {
        state.applicantFilters.years_of_experience_min = payload;
        state.applicantFilters = { ...state.applicantFilters };
    },

    updateYearsOfExperienceMaximum(state, payload) {
        state.applicantFilters.years_of_experience_max = payload;
        state.applicantFilters = { ...state.applicantFilters };
    },

    updateRatingMinimum(state, payload) {
        state.applicantFilters.rating_min = payload;
        state.applicantFilters = { ...state.applicantFilters };
    },

    updateRatingMaximum(state, payload) {
        state.applicantFilters.rating_max = payload;
        state.applicantFilters = { ...state.applicantFilters };
    },

    updateNumOfSeatsFilter(state, payload) {
        state.facilityFilters.num_of_seats_filter = JSON.stringify(payload);
        state.facilityFilters = { ...state.facilityFilters };
    },

    updateFacilityLocation(state, pk) {
        if (pk || pk == 0) {
            state.facilityFilters.location = pk;
            state.facilityFilters = { ...state.facilityFilters };
        }
    },

    updateSelectedLocation(state, pk) {
        if (pk || pk == 0) {
            state.applicantFilters.location = pk;
            state.applicantFilters = { ...state.applicantFilters };
            if (pk != -1) {
                state.facilityFilters.locations = pk;
                state.facilityFilters = { ...state.facilityFilters };
            }
        }
    },

    clearSelectedLocation(state) {
        delete state.applicantFilters['location'];
        delete state.facilityFilters['location'];
        state.applicantFilters = { ...state.applicantFilters };
        state.facilityFilters = { ...state.facilityFilters };
        if (state.selectedHeaderLocation.pk != -2) {
            state.selectedHeaderLocation = { pk: '' };
        }
    },

    toggleAgent(state, payload) {
        state.applicantFilters.agent = payload;
        state.applicantFilters = { ...state.applicantFilters };
    },

    toggleFreelance(state, payload) {
        state.applicantFilters.freelance = payload;
        state.applicantFilters = { ...state.applicantFilters };
    },

    toggleOutbound(state, payload) {
        state.applicantFilters.outbound_voice = payload;
        state.applicantFilters = { ...state.applicantFilters };
    },

    toggleInbound(state, payload) {
        state.applicantFilters.inbound_voice = payload;
        state.applicantFilters = { ...state.applicantFilters };
    },

    removeVoiceProcessFilters(state) {
        delete state.applicantFilters.inbound_voice;
        delete state.applicantFilters.outbound_voice;
        state.applicantFilters = { ...state.applicantFilters };
    },

    setMaxSalary(state, maxSalary) {
        state.maxSalary = maxSalary;
    },

    updateFeedItemsCount(state, count) {
        state.feedItemsCount = count;
    },

    toggleSelectedLocation(state, show) {
        if (show) {
            state.applicantFilters.location = state.booking.location.pk;
        } else {
            delete state.applicantFilters.location;
        }
        state.applicantFilters = { ...state.applicantFilters };
    },

    updateApplicantFilterLocation(state, data) {
        state.applicantFilters.location = data;
        state.applicantFilters = { ...state.applicantFilters };
    },

    updateSelectedHeaderLocation(state, location) {
        if (location) {
            state.selectedHeaderLocation = location;
        }
    },

    resetBookingStore(state) {
        const initial = initialState();
        Object.keys(initial).forEach(key => {
            state[key] = initial[key];
        });
    },

    updateApplicantsToRemove(state, pk) {
        if (state.toBeRemoved.indexOf(pk) > -1) {
            state.toBeRemoved.splice(state.toBeRemoved.indexOf(pk), 1);
        } else {
            state.toBeRemoved.push(pk);
        }
    },

    emptyApplicantsToRemove(state) {
        state.toBeRemoved = [];
    },

    updateFacilityComputerSpec(state, data) {
        let facilitySpec = state.facilityComputerSpecs.find(spec => spec.facility_pk == data.facility_pk);
        if (facilitySpec) {
            facilitySpec.specs = data.specs;
        } else {
            state.facilityComputerSpecs.push(data);
        }
    },

    updatePartnerBookingSpec(state, data) {
        let spec = state.partnerBookingSpecs.find(spec => spec.partner_pk == data.partner_pk);
        if (spec) {
            spec.specs = data.specs;
        } else {
            state.partnerBookingSpecs.push(data);
        }
    },

    toggleSearchNewApplicants(state, payload) {
        state.applicantFilters.is_new = payload;
        state.applicantFilters = { ...state.applicantFilters };
    },

    updateApplicantFiltersCriterion(state, criterion) {
        state.applicantFilters.criterion = criterion;
    },

    updateContactInfo(state, payload = {}) {
        state.contactInfo = payload;
    },

    updateFeedApplicantsOrdering(state, data) {
        state.applicantsOrdering = data;
    },

    updateFeedFacilitiesOrdering(state, data) {
        state.facilitiesOrdering = data;
    },

    updateFacilityPriceFilter(state, data) {
        const { minimum, maximum, currency } = data;
        state.facilityFilters.min_price = minimum;
        state.facilityFilters.max_price = maximum;
        state.facilityFilters.currency = currency;
        state.facilityFilters = { ...state.facilityFilters };
    },

    resetFacilityPriceFilter(state) {
        delete state.facilityFilters.min_price;
        delete state.facilityFilters.max_price;
        delete state.facilityFilters.currency;
        state.facilityFilters = { ...state.facilityFilters };
    },

    updateFacilitySeatsFilter(state, data) {
        const { minimum, maximum } = data;
        state.facilityFilters.min_no_seats = minimum;
        state.facilityFilters.max_no_seats = maximum;
        state.facilityFilters = { ...state.facilityFilters };
    },

    resetFacilitySeatsFilter(state) {
        delete state.facilityFilters.min_no_seats;
        delete state.facilityFilters.max_no_seats;
        state.facilityFilters = { ...state.facilityFilters };
    },

    updateFacilityFilterCheckBox(state, data) {
        for (let key in data) {
            if (!data[key]) {
                delete state.facilityFilters[key];
            } else {
                state.facilityFilters[key] = data[key];
            }
        }
        state.facilityFilters = { ...state.facilityFilters };
    },
};

const actions = {
    createBooking({ commit }, data) {
        let user = data.user;
        let location = data.location;

        const form = new FormData();
        form.append('payable_amount', 0);

        if (location) {
            form.append('booking_location', location);
        }

        if (user) {
            form.append('user_id', user.pk);
        }

        if (state.startDate) {
            form.append('start_date', state.startDate);
        }

        if (data.contact_info) {
            form.append('contact_info', data.contact_info);
        }

        return Booking.objects.create(form).then(function(data) {
            commit('updateBooking', data.booking);
            commit('updateStatus', null);
            return data.booking;
        });
    },

    async updateTPBooking({ state }, pk = null) {
        const form = new FormData();
        if (state.facilityComputerSpecs && state.selectedFacility) {
            let facilitySpec = state.facilityComputerSpecs.find(spec => {
                return spec.facility_pk == state.selectedFacility;
            });
            if (facilitySpec) {
                let arr = [...facilitySpec.specs];
                let specs = [];
                for (let item of arr) {
                    specs.push(Object.assign({}, item));
                }
                for (let spec of specs) {
                    for (let key in spec) {
                        if (spec[key].pk) {
                            spec[key] = spec[key].pk;
                        }
                    }
                }
                form.append('computer_specs_proposal', JSON.stringify(specs));
            }
        }

        return TPBooking.objects.update(pk, form).then(function(data) {
            return data;
        });
    },

    async updateBooking({ commit, state }, user_id = null) {
        const form = new FormData();
        form.append('payable_amount', 0);

        if (user_id) {
            form.append('user_id', user_id);
        }

        if (state.selectedFacility) {
            form.append('facility_id', state.selectedFacility);
        }

        if (state.selectedApplicants.length > 0) {
            form.append('applicant_ids', [...state.selectedApplicants, []]);
        }

        if (state.startDate) {
            form.append('start_date', state.startDate);
        }

        if (state.status) {
            form.append('status', state.status);
        }

        if (state.selectedHeaderLocation) {
            form.append('booking_location', state.selectedHeaderLocation.pk);
        }

        if (state.facilityComputerSpecs && state.selectedFacility) {
            let facilitySpec = state.facilityComputerSpecs.find(spec => {
                return spec.facility_pk == state.selectedFacility;
            });
            if (facilitySpec) {
                let arr = [...facilitySpec.specs];
                let specs = [];
                for (let item of arr) {
                    specs.push(Object.assign({}, item));
                }
                for (let spec of specs) {
                    for (let key in spec) {
                        if (spec[key].pk) {
                            spec[key] = spec[key].pk;
                        }
                    }
                }
                form.append('booking_computer_specs', JSON.stringify(specs));
            }
        }

        return await Booking.objects.update({ 'pk': state.booking.pk }, form).then(function(data) {
            commit('updateBooking', data);
            return data;
        });
    },

    deleteBooking({ commit }, pk) {
        return Booking.objects.delete({ 'pk': pk }).then(function(data) {
            commit('updateBooking', {});
            return data;
        });
    },

    async removeBookingInvitedApplicants({ commit, state }, toRemove) {
        if (state.booking && state.booking.invited_applicants) {
            let applicant_ids = state.booking.invited_applicants
                .map(applicant => applicant.pk)
                .filter(applicant => !toRemove.includes(applicant));
            applicant_ids.push(null);
            return await Booking.objects.update({ 'pk': state.booking.pk }, { applicant_ids }).then(function(data) {
                commit('updateBooking', data);
                state.selectedApplicantsInfo.filter(applicant => toRemove.includes(applicant.pk))
                    .map(applicant => commit('toggleSelectedApplicant', applicant));
                state.toBeRemoved = [];
            });
        } else {
            state.selectedApplicantsInfo.filter(applicant => toRemove.includes(applicant.pk))
                .map(applicant => commit('toggleSelectedApplicant', applicant));
            state.toBeRemoved = [];
        }

        return;
    },

    async inviteMoreApplicants({ commit, state }, booking_id) {
        const form = new FormData();

        if (state.selectedApplicants.length > 0) {
            form.append('applicant_ids', [...state.selectedApplicants, []]);
        }

        return Booking.objects.update({ 'pk': booking_id }, form).then(function(data) {
            commit('updateBooking', data);
            return data;
        });

    },

    inviteMoreApplicantsByCampaign({ state }, campaign_id) {
        const form = new FormData();

        if (state.selectedApplicants.length > 0) {
            form.append('applicant_ids', [...state.selectedApplicants, []]);
        }

        return CampaignInvitedApplicant.objects.update({ 'pk': campaign_id }, form);
    },

    inviteMoreApplicantsByJobPosting({ state }, data) {
        const form = new FormData();

        if (state.selectedApplicants.length > 0) {
            form.append('applicant_ids', [...state.selectedApplicants, []]);
            form.append('job_posting_id', data.job_posting_id);
            form.append('workforce_id', data.workforce_id);
            form.append('booking_id', data.booking_id);
        }

        return JobPostingApplication.objects.create(form);
    },

    fetchBooking(context, id) {
        return Booking.objects.get(id).then(function(data) {
            if (!data.error) {
                context.commit('updateBooking', data);

                if (data.facility_booking) {
                    context.commit('updateFacility', data.facility_booking.facility.pk);
                }
                if (data.invited_applicants) {
                    data.invited_applicants.map(applicant => context.commit('toggleSelectedApplicant', applicant));
                }
                if (data.start_date) {
                    context.commit('updateStartDate', data.start_date);
                }

                if (data.location) {
                    context.commit('updateSelectedLocation', data.location.pk);
                } else {
                    Locations.objects.filter().then(() => {
                        context.commit('updateSelectedHeaderLocation', { name: 'Work From Home', pk: -1 });
                        context.commit('toggleFreelance', true);
                    });
                }
            }

            return data;
        }).catch(error => {
            if (error.status == 403 || error.status == 404) {
                router.push({ name: 'bookings-facilities-and-applicants-feed' });
                state.selectedHeaderLocation = { pk: '' };
            }
        });
    },

    cancelBooking(context, id) {
        return Booking.objects.update({ pk: id }, { action: 'cancel' });
    },

    createAccount({ commit }, employer) {
        const form = new FormData();
        form.append('first_name', employer.first_name);
        form.append('last_name', employer.last_name);
        form.append('email', employer.email);
        form.append('company_name', employer.company_name);
        form.append('country', employer.country);
        form.append('phone_country_code', employer.phone_country_code);
        form.append('phone_number', employer.phone_number);
        form.append('password', employer.password);
        form.append('confirmation', employer.confirmation);
        form.append('region', employer.region);

        return Company.objects.create(form).then(function(data) {
            if (data.error_message) {
                return data;
            }
            let complete_phone_number = data.user_profile.phone_country_code + data.user_profile.phone_number;
            let employer = {
                company_name: data.name,
                complete_phone_number: complete_phone_number,
                email: data.user_profile.user.email,
                first_name: data.user_profile.user.first_name,
                last_name: data.user_profile.user.last_name,
                user_id: data.user_profile.user.pk
            };
            commit('updateEmployer', employer);
            return data;
        }).catch(response => {
            console.error(response);
        });
    },

    // TODO: When this function is implemented,
    // argument should have workforce_id instead of
    // campaign_id
    fetchLiveActiveApplicants(context, data) {
        let top = data.top ? data.top : 0;
        let fetchSelected = data.fetchSelected ? data.fetchSelected : false;
        let workforce_id = data.workforce_id ? data.workforce_id : null;
        let size_per_request = data.size_per_request ? data.size_per_request : 24;

        let filters = fetchSelected ? { ids: state.selectedApplicants } : state.applicantFilters;
        if (workforce_id) {
            filters['pending_and_uninvited_applicants_by_workforce_id'] = workforce_id;
        }
        if (data.location) {
            filters['location'] = data.location;
        }
        if (data.specialty_pk) {
            filters['specialty_pk'] = data.specialty_pk;
        }
        return LiveActiveApplicant.objects.filter(filters, { top, size_per_request }).then(function(data) {
            context.commit('updateFeedItemsCount', data.count);
            return data;
        });
    },

    fetchFacilities(context, { top = 0, size_per_request = 24, building_pks = [] }) {
        let filters = { ...state.facilityFilters };

        if (filters.Object?.prototype.hasOwnProperty.call('start_date') && !filters.start_date) {
            delete filters['start_date'];
        }
        filters['building_pks'] = building_pks;
        filters['facilities_order_by'] = state.facilitiesOrdering;
        return Facility.objects.filter(filters, { top, size_per_request }).then(function(data) {
            context.commit('updateFeedItemsCount', data.count);
            context.commit('updateFeedFacilitiesOrdering', data.facilities_order_by);
            return data;
        });
    },

    fetchApplicantsFacilities({ commit, state }, {
        page = 1, fetchTrustedPartners = true, fetchApplicants = false, fetchFacilities = true }) {
        let feedFilters = { page, fetchTrustedPartners, fetchApplicants, fetchFacilities };
        feedFilters = Object.assign(feedFilters, state.applicantFilters);
        feedFilters = Object.assign(feedFilters, state.facilityFilters);

        if (feedFilters.Object.prototype.hasOwnProperty.call('start_date') && !feedFilters.start_date) {
            delete feedFilters['start_date'];
        }

        feedFilters['applicants_order_by'] = state.applicantsOrdering;
        feedFilters['facilities_order_by'] = state.facilitiesOrdering;
        return Feed.objects.filter(feedFilters).then(function(data) {
            commit('updateFeedItemsCount', data.count);
            commit('updateFeedApplicantsOrdering', data.applicants_order_by);
            commit('updateFeedFacilitiesOrdering', data.facilities_order_by);
            return data;
        });
    },

    fetchBookingActivity() {
        return SiteBookingActivity.objects.filter().then(data => {
            return (data.status === 200) ? data.ongoing_bookings : null;
        });
    },

    fetchFacilityById(context, pk) {
        return Facility.objects.get(pk);
    },

    fetchApplicantById(context, pk) {
        return Applicant.objects.get(pk);
    },

    fetchApplicantByEmail(context, email) {
        return Applicant.objects.filter({ email_address: email });
    },

    fetchTrustedPartnerById(context, pk) {
        return TrusterPartner.objects.get(pk);
    },

    fetchApplicantLocations(context, pk) {
        return ApplicantLocation.objects.get(pk);
    },

    fetchComputerSpecsParts() {
        return ComputerSpecPart.objects.filter();
    },

    fetchInterviewQuestions(context, slug) {
        return InterviewQuestions.objects.filter({ slug: slug });
    },

    sendCustomOfficeRequest(context, custom_office) {
        const form = new FormData();

        form.append('company_name', custom_office.companyName);
        form.append('name', custom_office.name);
        form.append('email_address', custom_office.email);
        form.append('phone_country_code', custom_office.phoneCountryCode);
        form.append('phone_number', custom_office.phoneNumber);
        form.append('remarks', custom_office.remarks);

        return CustomOffice.objects.create(form);
    },

    async fetchJobPostings(context, data) {
        return await JobPosting.objects.filter(data).then(function(data) {
            context.commit('updateFeedItemsCount', data.count);
            return data;
        });
    },

    createBookingCheckout({ state }) {
        const form = new FormData();

        let applicant_pks = [];
        state.selectedApplicantSubscriptions.forEach(applicant => {
            applicant_pks.push(applicant.pk);
        });

        form.append('booking_id', state.booking.pk);
        form.append('applicant_pks', JSON.stringify(applicant_pks));

        return BookingCheckout.objects.create(form);
    },

    submitBookingCheckout(context, data) {
        return CheckoutBooking.objects.update({ 'pk': data.pk });
    },

    fetchTrustedPartnerBooking(context, data) {
        let filters = {};
        if (data.partner_id) {
            filters.partner_id = data.partner_id;
        }

        if (data.booking_id) {
            filters.booking_id = data.booking_id;
        }
        return TrusterPartnerBooking.objects.filter(filters);
    },

    createTrusterPartnerBooking(context, data) {
        const form = new FormData();
        form.append('trusted_partner_id', data.trusted_partner_id);
        form.append('confirm', data.confirm);

        let arr = [...data.job_focuses];
        let job_focuses = [];
        for (let item of arr) {
            let obj = {};
            obj['pk'] = item.pk;
            obj['specialties'] = [];
            for (let specialty of item.job_specialties) {
                obj['specialties'].push({
                    'pk': specialty.pk,
                    'count': specialty.count,
                });
            }
            job_focuses.push(Object.assign({}, obj));
        }

        form.append('job_focuses', JSON.stringify(job_focuses));
        return TrusterPartnerBooking.objects.create(form);
    },

    updateTrustedPartnerBooking(context, data) {
        const form = new FormData();
        form.append('confirm', data.confirm);

        let arr = [...data.job_focuses];
        let job_focuses = [];
        for (let item of arr) {
            let obj = {};
            obj['pk'] = item.pk;
            obj['specialties'] = [];
            for (let specialty of item.job_specialties) {
                obj['specialties'].push({
                    'pk': specialty.pk,
                    'count': specialty.count,
                });
            }
            job_focuses.push(Object.assign({}, obj));
        }
        form.append('job_focuses', JSON.stringify(job_focuses));

        return TrusterPartnerBooking.objects.update({ 'pk': data.pk }, form);
    },

    fetchTrustedPartnerBookingMessages(context, data) {
        let filters = {
            trusted_partner_booking_id: data.pk,
            latest_message_pk: data.latest_message_pk,
        };
        return TrusterPartnerBookingMessages.objects.filter(filters);
    },

    sendTrustedPartnerBookingMessage(context, data) {
        const form = new FormData();
        form.append('trusted_partner_booking_id', data.trusted_partner_booking_id);
        form.append('text', data.text);
        if (data.price_update) {
            form.append('price_update', data.price_update);
        }

        if (data.currency) {
            form.append('currency', data.currency);
        }

        if (data.job_specialties) {
            let arr = [...data.job_specialties];
            let job_specialties = [];
            for (let item of arr) {
                let obj = {};
                obj['pk'] = item.pk;
                obj['new_hourly_rate'] = {
                    'amount': item.altered_hourly_rate,
                    'conversion_rate': item.hourly_rate.conversion_rate,
                    'code': item.hourly_rate.code,
                };
                job_specialties.push(Object.assign({}, obj));
            }

            form.append('job_specialties', JSON.stringify(job_specialties));
        }
        return TrusterPartnerBookingMessages.objects.create(form);
    },

    fetchTrustedBookingNegotiation(context, pk) {
        return TrusterPartnerBookingNegotiation.objects.filter({
            'trusted_partner_booking_id': pk,
        });
    },

    getInitialTPFacility(context, pk) {
        return TPBooking.objects.get(pk);
    },

    approveFacility(context, data) {
        return PartnerFacility.objects.update({ pk: data['pk'] });
    },

    fetchTPDashboard(context, filter) {
        return TPBookingDashboard.objects.filter(filter);
    },

    createFacilityProposal(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return PartnerFacility.objects.create(form);
    },

    fetchSuggestedTrustedPartner(context, filter={}) {
        return SuggestedTrustedPartner.objects.filter(filter);
    },

    updateTPBookingPreferredBuilding(context, data) {
        const form = new FormData();
        form.append('building_ids', JSON.stringify(data.building_ids));
        return TPBookingPreferredBuilding.objects.update({ 'pk': data.pk }, form);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
